const ACL_VIEW_NAME_PREFIX = "acl_view_name";

export const getAclViewClassName = (key: string) =>
  `${ACL_VIEW_NAME_PREFIX}_${key.toLowerCase()}`;
